import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

/**
 * Shared completion screen after a candidate submits (or was already completed).
 */
export default function TestResult({ result }) {
  const iconWrapClass = result.passed
    ? "bg-[hsl(var(--success))]/10"
    : result.passed === false
    ? "bg-[hsl(var(--destructive))]/10"
    : "bg-secondary";
  const iconColorClass = result.passed
    ? "text-[hsl(var(--success))]"
    : result.passed === false
    ? "text-[hsl(var(--destructive))]"
    : "text-muted-foreground";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full border-border bg-card" data-testid="test-result-card">
        <CardContent className="p-8 text-center">
          <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${iconWrapClass}`}>
            <CheckCircle className={`w-8 h-8 ${iconColorClass}`} />
          </div>
          <h2 className="text-2xl font-display font-semibold mb-2">Assessment Complete</h2>
          {result.score_pct !== undefined ? (
            <>
              <p className="text-4xl font-display font-semibold mt-4 mb-1">{result.score_pct}%</p>
              <p className="text-muted-foreground">
                {result.correct}/{result.total} correct
              </p>
            </>
          ) : (
            <p className="text-muted-foreground mt-2">{result.message}</p>
          )}
          <div className="bg-secondary/50 rounded-lg p-4 mt-6">
            <p className="text-sm text-muted-foreground">
              Thank you for completing the assessment. The hiring team will review your results and contact you with next steps.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
